<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <keywords-form :keyword="keyword" :disabled="disabled" @activate-mod="activateMod()"
                              @click="updateKeyword()"
                              :showLabels="true"></keywords-form>
            </div>
        </div>
    </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import keywordsApi from '../../api/keywords'
  import keywordsForm from './Form.vue'

  export default {

    components: {
      keywordsForm
    },

    data () {
      return {
        keyword: false,
        disabled: true,
        interval: null
      }
    },

    beforeCreate () {
      keywordsApi.show(this.$route.params.id)
        .then((response) => {
          this.keyword = response
        })
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Keywords inserite',
        createButton: {
          display: true,
          text: 'Nuova keyword',
          to: '/keyword'
        }
      })
      this.interval = setInterval(() => {
        if (!this.disabled) {
          keywordsApi.update(this.$route.params.id, this.keyword)
        }
      }, process.env.AUTOSAVE_TIMEOUT)
    },

    beforeDestroy () {
      clearInterval(this.interval)
    },

    methods: {
      activateMod () {
        this.disabled = !this.disabled
      },
      updateKeyword () {
        this.loader = true
        return keywordsApi.update(this.$route.params.id, this.keyword)
          .then((response) => {
            toastr.success('La keyword è stata salvata correttamente')
            this.loader = false
            this.disabled = true
          })
          .catch((response) => {
            this.loader = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/keywords/Show.vue